import styled from '@emotion/styled'
import { Button } from '@hhgtech/hhg-components/components'
import { theme, MediaQueries } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledOvulationCalculatorCard = styled.div`
  background-color: #fff;
  border: 1px solid ${theme.colors.neutral100};
  position: relative;
  border-radius: ${theme.borderRadius};

  &[data-in-range='none'],
  &[data-in-range='period'] {
    .highlighted {
      color: ${theme.colors.pink700};
    }
  }

  &[data-in-range='fertile'] {
    .highlighted {
      color: ${theme.colors.green700};
    }
  }

  .onboarding-calendar {
    .cal-nav-prev,
    .cal-nav-next {
      top: 40px;
    }

    ${MediaQueries.mbDown} {
      max-width: 476px;
      margin: auto;
    }
  }
`

export const StyledOvulationCalculatorCardCalTooltip = styled.div`
  position: absolute;
  top: 53px;
  left: 24px;
  min-height: 100px;
  z-index: 100;
  background-color: white;
  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: ${theme.borderRadius};
`

export const StyledOvulationCalculatorCardHead = styled.div`
  ${MediaQueries.mbDown} {
    padding: 8px 16px;
    display: flex;
    justify-content: center;
  }

  ${MediaQueries.mbUp} {
    padding: 16px 24px;
  }
`

export const StyledCardHeadCalButton = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border: 1px solid;
  border-radius: ${theme.borderRadius};
  font-size: 14px;
  width: fit-content;
  font-weight: ${theme.sizes.fwBold};

  &,
  > div,
  path {
    transition: all 0.2s linear;
  }

  ${MediaQueries.mbDown} {
    color: ${theme.colors.gray600};
    border-color: transparent;
  }

  ${MediaQueries.mbUp} {
    color: ${theme.colors.gray800};
    border-color: ${theme.colors.gray400};
    &:hover,
    &[data-active='true'] {
      color: ${theme.colors.white};
      border-color: ${theme.colors.primary800};
      background-color: ${theme.colors.primary800};

      svg path {
        fill: ${theme.colors.white};
      }
    }
  }
`

export const StyledOvulationCalculatorCardBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;

  margin-top: 20px;

  [data-in-range='none'] & {
    background-color: ${theme.colors.neutral50};
  }
  [data-in-range='period'] & {
    background-color: rgba(255, 241, 246, 0.5);
  }
  [data-avoid-pregnancy='false'][data-in-range='fertile'] & {
    background-color: #effbf6;
  }
  [data-avoid-pregnancy='true'][data-in-range='fertile'] & {
    background-color: #fcf4f3;
  }
  .risky {
    font-weight: bold;
    color: ${theme.colors.error};
  }
`

export const StyledOvulationCalculatorCardBodyEditButton = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  width: 32px;
  height: 32px;
  border: 1px solid ${theme.colors.gray300};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledOvulationCalculatorCardBodyTitle1 = styled.p`
  font-size: 18px;
  font-weight: 600;
`

export const StyledOvulationCalculatorCardBodyTitle2 = styled.p`
  padding: 16px 0;
  font-size: 32px;
  font-weight: bold;
`

export const StyledOvulationCalculatorCardBodyDetails = styled.p`
  font-size: 16px;
  color: ${theme.colors.gray600};
  .rate {
    font-weight: 700;
    font-size: 20px;
  }
`

export const StyledOvulationCalculatorCardBodyButton = styled(Button)`
  margin-top: 20px;
  color: ${theme.colors.primaryBase};
`

export const StyledOvulationCalculatorCardFoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 8px;
  gap: 4px;
`

export const StyledOvulationCalculatorCardFootItem = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`

export const StyledOvulationCalculatorCardFootItemBadge = styled.div`
  width: 16px;
  height: 10px;
  border-radius: 16px;
  &.badge--period {
    background-color: ${theme.colors.pink100};
  }
  &.badge--fertile {
    background-color: ${theme.colors.green100};
  }
  &.badge--ovulation {
    width: 12px;
    height: 12px;
    border: 1.5px dashed ${theme.colors.green700};
  }
  [data-avoid-pregnancy='true'] & {
    &.badge--ovulation {
      border-color: ${theme.colors.error};
    }
  }
`

export const StyledOvulationCalculatorCardFootItemLabel = styled.div`
  font-size: 12px;
`
